import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { userApi, setUserToken, getUserToken } from "@/lib/api";
import PublicHeader from "@/components/PublicHeader";
import { toast } from "sonner";

const UserLogin = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  // If already logged in, jump to /riservati
  if (getUserToken()) {
    return <RedirectReserved />;
  }

  const submit = async (e) => {
    e.preventDefault();
    if (!username.trim() || !password) {
      return toast.error("Username e password richiesti");
    }
    setLoading(true);
    try {
      const { data } = await userApi.post("/user/login", {
        username: username.trim().toLowerCase(),
        password,
      });
      setUserToken(data.token, data.username);
      toast.success(`Bentornato, ${data.username}`);
      nav("/riservati");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Errore di accesso");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="user-login-page" className="min-h-screen bg-[#f9f8f6]">
      <PublicHeader />
      <main className="max-w-md mx-auto px-6 sm:px-10 pt-24 pb-20">
        <p className="font-sans text-[10px] sm:text-xs tracking-[0.35em] uppercase text-[#4a4843] mb-3 text-center">
          Lettori
        </p>
        <h1 className="font-serif text-4xl sm:text-5xl text-center text-[#1a1918] tracking-tight font-light mb-3">
          Accedi
        </h1>
        <p className="font-serif italic text-center text-[#4a4843] mb-12 leading-relaxed">
          Spazio riservato. L'accesso è creato dall'autore del diario.
        </p>

        <form onSubmit={submit} data-testid="user-login-form" className="space-y-6">
          <div>
            <label className="block font-sans text-[10px] tracking-[0.3em] uppercase text-[#4a4843] mb-2">
              Username
            </label>
            <input
              data-testid="user-login-username"
              type="text"
              autoFocus
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
              className="w-full bg-transparent border-0 border-b border-[#1a1918] py-3 font-serif text-xl focus:outline-none focus:border-[#d4b886]"
            />
          </div>
          <div>
            <label className="block font-sans text-[10px] tracking-[0.3em] uppercase text-[#4a4843] mb-2">
              Password
            </label>
            <input
              data-testid="user-login-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              className="w-full bg-transparent border-0 border-b border-[#1a1918] py-3 font-serif text-xl focus:outline-none focus:border-[#d4b886]"
            />
          </div>
          <button
            type="submit"
            data-testid="user-login-submit"
            disabled={loading || !username || !password}
            className="w-full bg-[#1a1918] text-[#f9f8f6] hover:bg-[#4a4843] transition-colors py-4 font-sans text-xs tracking-[0.3em] uppercase disabled:opacity-50"
          >
            {loading ? "accesso…" : "entra"}
          </button>
        </form>

        <p className="font-serif italic text-center text-[#4a4843] text-sm mt-10 leading-relaxed">
          L'accesso agli attraversamenti riservati è autorizzato dall'amministratore del sito.
        </p>
        <p className="text-center mt-6">
          <Link to="/" className="font-sans text-[10px] tracking-[0.3em] uppercase text-[#4a4843] hover:text-[#1a1918]">
            ← torna al diario
          </Link>
        </p>
      </main>
    </div>
  );
};

const RedirectReserved = () => {
  const nav = useNavigate();
  setTimeout(() => nav("/riservati", { replace: true }), 0);
  return null;
};

export default UserLogin;
